<template>
    <div class="q-pa-md">
        <div class="row">
            <div class="col-12" v-if="numPages > 1">
                <div class="text-center">
                    <q-icon name="mdi-minus" size="md" style="cursor: pointer;" color="primary"
                        @click="AnteriorPagina"></q-icon>
                    {{ page }} /{{ numPages }}
                    <q-icon name="mdi-plus" size="md" style="cursor: pointer;" color="primary"
                        @click="SiguientePagina"></q-icon>
                </div>
            </div>
            <div style="width: 100%">
                <pdf ref="pdf" :src="pdfBase64" :page="page" :rotate="rotate" @progress="loadedRatio = $event"
                    @num-pages="numPages = $event" @link-clicked="page = $event"></pdf>
            </div>
        </div>
    </div>
</template>

<script>
import { QSpinnerClock } from 'quasar'
import pdf from 'vue-pdf';

export default {
    components: {
        pdf: pdf
    },
    name: 'VisualizadorPDF',
    data() {
        return {
            pdfUrl: null,
            pdfDoc: null,
            loadedRatio: 0,
            page: 1,
            numPages: 0,
            rotate: 0,
            logoBase64: ''
        }
    },
    mounted() {
    },
    created() {
    },
    computed: {
        pdfBase64() {
            return this.$store.state.auth.storeBase64Cotizacion;
        },

    },
    methods: {
        SiguientePagina() {
            let paginas = this.numPages;
            if (this.page < paginas) {
                this.page++;
            } else {
                // this.page = 1;
            }
        },

        AnteriorPagina() {
            let paginas = this.numPages;
            if (this.page > paginas) {
                this.page--;
            } else {
                this.page = 1;
            }
        },

    }
}
</script>